var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "form",
    {
      on: {
        submit: function ($event) {
          $event.preventDefault()
          return _vm.submit.apply(null, arguments)
        },
      },
    },
    [
      _c(
        "div",
        {
          staticClass: "modal-card",
          staticStyle: {
            "min-width": "50vw",
            width: "fit-content",
            "min-height": "80vh",
            height: "fit-content",
          },
        },
        [
          _c("header", { staticClass: "modal-card-head" }, [
            _c("p", { staticClass: "modal-card-title" }, [
              _vm._v(" New Inventory "),
              _c(
                "span",
                {
                  staticStyle: {
                    "font-size": "1rem",
                    "text-overflow": "elipsis",
                  },
                },
                [_vm._v(_vm._s(_vm.plant.name))]
              ),
            ]),
          ]),
          _c(
            "section",
            { staticClass: "modal-card-body" },
            [
              _c(
                "b-field",
                { attrs: { grouped: "" } },
                [
                  _c(
                    "b-field",
                    { attrs: { label: "Crate Type" } },
                    [
                      _c("multiselect", {
                        staticStyle: { "min-width": "400px" },
                        attrs: {
                          options: _vm.crateTypes,
                          multiple: true,
                          "close-on-select": true,
                          placeholder: "Pick plant",
                          "custom-label": (obj) => obj.name,
                          "track-by": "name",
                        },
                        model: {
                          value: _vm.selectedCrates,
                          callback: function ($$v) {
                            _vm.selectedCrates = $$v
                          },
                          expression: "selectedCrates",
                        },
                      }),
                    ],
                    1
                  ),
                  _c(
                    "b-field",
                    { attrs: { label: "Date" } },
                    [
                      _c("b-datepicker", {
                        attrs: {
                          name: "date",
                          "first-day-of-week": 1,
                          locale: "en-CA",
                          icon: "calendar-alt",
                          placeholder: "Date",
                        },
                        model: {
                          value: _vm.date,
                          callback: function ($$v) {
                            _vm.date = $$v
                          },
                          expression: "date",
                        },
                      }),
                    ],
                    1
                  ),
                ],
                1
              ),
              _vm._l(_vm.selectedCrates, function (selectedCrate) {
                return _c(
                  "b-field",
                  { key: selectedCrate.name, attrs: { grouped: "" } },
                  [
                    _c(
                      "b-field",
                      {
                        attrs: {
                          label: "Number of Clean " + selectedCrate.name,
                        },
                      },
                      [
                        _c("b-input", {
                          attrs: {
                            type: "number",
                            placeholder: "Clean Crates",
                            min: "0",
                          },
                          model: {
                            value: _vm.cleanCrates[selectedCrate.value],
                            callback: function ($$v) {
                              _vm.$set(
                                _vm.cleanCrates,
                                selectedCrate.value,
                                $$v
                              )
                            },
                            expression: "cleanCrates[selectedCrate.value]",
                          },
                        }),
                        _c("b-button", { on: { click: _vm.clearClean } }, [
                          _vm._v(" Clear "),
                        ]),
                      ],
                      1
                    ),
                    _c(
                      "b-field",
                      {
                        attrs: {
                          label: "Number of Dirty " + selectedCrate.name,
                        },
                      },
                      [
                        _c("b-input", {
                          attrs: {
                            type: "number",
                            placeholder: "Dirty Crates",
                            min: "0",
                          },
                          model: {
                            value: _vm.dirtyCrates[selectedCrate.value],
                            callback: function ($$v) {
                              _vm.$set(
                                _vm.dirtyCrates,
                                selectedCrate.value,
                                $$v
                              )
                            },
                            expression: "dirtyCrates[selectedCrate.value]",
                          },
                        }),
                        _c("b-button", { on: { click: _vm.clearDirty } }, [
                          _vm._v(" Clear "),
                        ]),
                      ],
                      1
                    ),
                    _c(
                      "b-field",
                      {
                        attrs: {
                          label: "Number to Repair " + selectedCrate.name,
                        },
                      },
                      [
                        _c("b-input", {
                          attrs: {
                            type: "number",
                            placeholder: "Repair Crates",
                            min: "0",
                          },
                          model: {
                            value: _vm.repairCrates[selectedCrate.value],
                            callback: function ($$v) {
                              _vm.$set(
                                _vm.repairCrates,
                                selectedCrate.value,
                                $$v
                              )
                            },
                            expression: "repairCrates[selectedCrate.value]",
                          },
                        }),
                        _c("b-button", { on: { click: _vm.clearRepair } }, [
                          _vm._v(" Clear "),
                        ]),
                      ],
                      1
                    ),
                  ],
                  1
                )
              }),
            ],
            2
          ),
          _c("footer", { staticClass: "modal-card-foot" }, [
            _c(
              "button",
              {
                staticClass: "button is-info is-fullwidth",
                attrs: { type: "submit" },
              },
              [_vm._v(" " + _vm._s(_vm.$t("global.submit")) + " ")]
            ),
          ]),
        ]
      ),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }